import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { IMessage } from "../shared/interfaces/whatsapp.interface";
import { WhatsappDeliveryService } from "./whatsapp-delivery.service";
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class WhatsappNotificationService {
  private _baseUrl =
    environment.apiUrl + "/private/engines/whatsapp/notifications";

  constructor(
    private readonly _http: HttpClient,
    private readonly _waDelivery: WhatsappDeliveryService,
  ) {}

  getWaUnreadMessages = (companyId: number): Observable<any> => {
    return this._waDelivery.getWhatsappAccount(companyId).pipe(
      switchMap((waAccount) => {
        return this._http.get<any>(
          `${this._baseUrl}/unread-list/${waAccount.username}`
        );
      })
    );
  };

  getUnreadGroups = (companyId: number): Observable<any> => {
    console.log("UNREAD GROUP ", companyId);
    return this._waDelivery.getWhatsappAccount(companyId).pipe(
      switchMap((waAccount) => {
        return this._http.get<any>(
          `${this._baseUrl}/unread-groups/${waAccount.username}`
        );
      })
    );
  };

  updateIsReadStatus = (messageId: number) => {
    return this._http.put<any>(
      `${this._baseUrl}/update-is-read/${messageId}`,
      {}
    );
  };
}
